<template>
    <div class="job-order-container">
        <ThatsTable
            title=" "
            ref="table"
            endpoint="job-orders"
            :columns="columns"
            :newBtn="false"
            @openUpdateModal="openRecord"
        >
            <template #tabs>
                <mdb-tabs class="table-header-tabs" :active="0" default :links="[{ text: 'Job Orders' }]" />
            </template>
        </ThatsTable>
        <JobOrderForm ref="form" @success="refreshTable" />
    </div>
</template>

<script>
import ThatsTable from '../../components/thats/Table'
import JobOrderForm from './JobOrderForm'
import { mdbTabs } from 'mdbvue'

export default {
    components: { ThatsTable, JobOrderForm, mdbTabs },
    data() {
        return {
            columns: [
                { label: 'Job Order Series', field: 'series', clickable: true, width: '180' },
                { label: 'Invoice No.', field: 'invoice_series', width: '170' },
                { label: 'Customer', field: 'customer_name', width: '180' },
                { label: 'Document Date', field: 'document_date', width: '140' },
                { label: 'Requested Completion Date', field: 'requested_completion_date', width: '190' },
                { label: 'Committed Completion Date', field: 'committed_completion_date', width: '190' },
                { label: 'Person In Charge', field: 'person_in_charge', width: '180', formatter: value => value && value.name ? value.name : '-' },
                {
                    label: 'Status',
                    field: 'status',
                    badge: true,
                    badgeFormatter: value => ({
                        label: String(value || '').replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase()),
                        color: { draft: 'secondary', open: 'primary', released: 'info', in_progress: 'warning', on_hold: 'secondary', partially_completed: 'warning', completed: 'success', closed: 'dark', cancelled: 'danger' }[value] || 'secondary'
                    })
                }
            ]
        }
    },
    methods: {
        openRecord(row) {
            const record = row && row.row ? row.row : row
            if (record && record.id) this.$refs.form.openDialog(record.id)
        },
        refreshTable() {
            if (this.$refs.table) this.$refs.table.refreshTable()
        }
    }
}
</script>
